<section style="padding: 100px 0;">
    <div class="container text-center">
        <h1>404</h1>
        <h4>page not found</h4>
        <p>The page you're looking for does not exist</p>
    </div>
</section>